enum FeaturedListType {
  MASTER = "MASTER",
  DEFAULT = "DEFAULT",
  CUSTOM = "CUSTOM"
}

export default FeaturedListType;
